'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactDom = require("react-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _raf = _interopRequireDefault(require("raf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Grid =
/*#__PURE__*/
function (_Component) {
  _inherits(Grid, _Component);

  function Grid(props) {
    var _this;

    _classCallCheck(this, Grid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Grid).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.numVisibleRows = _this.getNumVisibleRows();

      if (!_this.ticking) {
        (0, _raf["default"])(_this.performUpdate);
        _this.ticking = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      _this.lastScrollY = _this.getScrollTop();

      if (!_this.ticking) {
        (0, _raf["default"])(_this.performUpdate);
        _this.ticking = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderRows", function () {
      var _this$props = _this.props,
          rowCount = _this$props.rowCount,
          rowHeight = _this$props.rowHeight,
          rowBuffer = _this$props.rowBuffer,
          renderRow = _this$props.renderRow,
          loading = _this$props.loading;
      var startIndex = 0;
      var endIndex = 0;

      if (loading) {
        endIndex = _this.numVisibleRows;
      } else {
        startIndex = Math.min(Math.floor(Math.max(_this.lastScrollY - _this.offsetTop, 0) / rowHeight), rowCount);
        startIndex = Math.max(startIndex - rowBuffer, 0);
        endIndex = Math.min(startIndex + _this.numVisibleRows + rowBuffer * 2, rowCount);
      }

      var numRows = endIndex - startIndex;
      var rows = new Array(numRows);

      for (var i = startIndex; i < endIndex; ++i) {
        var row = renderRow({
          rowIndex: i
        });
        rows.push(row);
      }

      return rows;
    });

    _defineProperty(_assertThisInitialized(_this), "performUpdate", function () {
      _this.forceUpdate();
    });

    _this.ticking = false;
    _this.scrollWrapper = null;
    _this.numVisibleRows = 0;
    _this.offsetTop = 0;
    _this.lastScrollY = 0;
    _this.state = {
      scrollbarWidth: null
    };
    return _this;
  }

  _createClass(Grid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this); // Reset scroll before we start doing any measurements

      node.scrollIntoView();

      if (this.props.useWindow) {
        this.scrollWrapper = window;
      } else {
        this.scrollWrapper = node;
      }

      this.offsetTop = this.getOffsetTop();
      this.numVisibleRows = this.getNumVisibleRows();
      this.lastScrollY = this.getScrollTop();
      this.forceUpdate();
      this.scrollWrapper.addEventListener('scroll', this.handleScroll, false);
      this.scrollWrapper.addEventListener('resize', this.handleResize, false);
      this.handleUpdateScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Only when changes are flushed in to the DOM do we try to rerender again
      this.ticking = false;
      this.handleUpdateScrollbarWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scrollWrapper.removeEventListener('scroll', this.handleScroll, false);
      this.scrollWrapper.removeEventListener('resize', this.handleResize, false);
    }
    /**
     * Calculates the scrollbar's width by calculating the difference of the inner
     * container from the outer container and calls onUpdateScrollbarWidth() prop
     * if the width has been updated.
     */

  }, {
    key: "handleUpdateScrollbarWidth",
    value: function handleUpdateScrollbarWidth() {
      if (!this.props.onUpdateScrollbarWidth) {
        return;
      }

      var virtualListNode = (0, _reactDom.findDOMNode)(this);

      if (virtualListNode) {
        var scrollbarWidth = virtualListNode.offsetWidth - virtualListNode.firstChild.offsetWidth;

        if (this.state.scrollbarWidth !== scrollbarWidth) {
          this.props.onUpdateScrollbarWidth(scrollbarWidth);
          this.setState({
            scrollbarWidth: scrollbarWidth
          });
        }
      }
    }
  }, {
    key: "getOffsetTop",
    value: function getOffsetTop() {
      if (this.scrollWrapper instanceof Window) {
        return (0, _reactDom.findDOMNode)(this).offsetTop;
      } else {
        return this.scrollWrapper.offsetTop;
      }
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      if (this.scrollWrapper instanceof Window) {
        return document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      } else {
        return this.scrollWrapper.scrollTop;
      }
    }
  }, {
    key: "getNumVisibleRows",
    value: function getNumVisibleRows() {
      var clientHeight = 0;

      if (this.scrollWrapper instanceof Window) {
        var documentHeight = document.documentElement && document.documentElement.clientHeight || document.body.clientHeight;
        clientHeight = documentHeight - this.offsetTop;
      } else {
        clientHeight = this.scrollWrapper.clientHeight;
      }

      var numVisibleRows = Math.floor(Math.max(clientHeight, 0) / this.props.rowHeight);
      return numVisibleRows;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          rowCount = _this$props2.rowCount,
          rowHeight = _this$props2.rowHeight,
          loading = _this$props2.loading,
          height = _this$props2.height,
          useWindow = _this$props2.useWindow;
      var outerClassName = (0, _classnames["default"])('virtual-list', className, {
        loading: loading
      });
      var outerStyle = {
        height: useWindow ? 'auto' : height,
        overflow: loading ? 'hidden' : 'auto',
        position: 'relative'
      };
      var innerClassname = (0, _classnames["default"])('virtual-list-inner-container', {
        loading: loading
      });
      var innerStyle = {
        height: loading ? this.numVisibleRows * rowHeight : rowCount * rowHeight,
        minHeight: rowHeight,
        overflow: 'hidden',
        position: 'relative'
      };
      return _react["default"].createElement("div", {
        className: outerClassName,
        style: outerStyle
      }, _react["default"].createElement("div", {
        className: innerClassname,
        style: innerStyle
      }, this.renderRows()));
    }
  }]);

  return Grid;
}(_react.Component);

_defineProperty(Grid, "propTypes", {
  rowCount: _propTypes.PropTypes.number.isRequired,
  rowHeight: _propTypes.PropTypes.number.isRequired,
  renderRow: _propTypes.PropTypes.func.isRequired,
  height: _propTypes.PropTypes.number.isRequired,
  rowBuffer: _propTypes.PropTypes.number,
  loading: _propTypes.PropTypes.bool,
  className: _propTypes.PropTypes.string,
  useWindow: _propTypes.PropTypes.bool,
  onUpdateScrollbarWidth: _propTypes.PropTypes.func
});

_defineProperty(Grid, "defaultProps", {
  rowBuffer: 20,
  loading: false,
  useWindow: false
});

var _default = Grid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rapiddot/react-virtual-list/lib/grid/index.js
// module id = 473
// module chunks = 0